import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { getLatestActivitySet } from 'lib/selectors/getLatestActivitySet';

const getLatestActivitySetClosedAt = createSelector(
  [getLatestActivitySet],
  (latestActivitySet) => {
    return _get(latestActivitySet, 'closedAt', null);
  }
);

export { getLatestActivitySetClosedAt };
